export default __webpack_public_path__ + "0e4672d22ec5d665ea3a3e1b3ccd0b45.svg";